import offlineDevicesByModelModal from './offline-devices-by-model-modal.connect'

export default offlineDevicesByModelModal
